export default __webpack_public_path__ + "static/media/i-refresh.7a8ddb25.svg";